import { EditComponent }                 from '../../app-lite/table/cell-components/actions/edit.component';
import { InvoiceContactStatusComponent } from '../../app-lite/invoices/contact-status/invoice.contact-status.component';

export function CustomerQuotesCtrl (
  $rootScope,
  $state,
  $scope,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showCustomerQuotes = !!$scope.quotes.length;
  $scope.tableCacheKey      = 'customerQuotes';

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    begin_date: '',
    end_date  : '',
    reference : ''
  });

  $scope.tableSettings = {
    broadcast: 'filterQuotes',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'job_card_number',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.QUOTE_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'cash_or_account',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.TYPE')
        },
        pipe: 'customerType'
      },
      {
        component: {
          enabled: true,
          factory: InvoiceContactStatusComponent
        },
        header: {
          classes: 'text-center',
          text   : $translate.instant('GENERAL_SPACE.STATUS.CONTACTED')
        },
        sortable: false
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('GENERAL_SPACE.FIELD.QUOTE_AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewQuote(event)
            }
          },
          enabled: !$scope.customer.archived,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_QUOTES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/quote_count_with_find/', [
        $scope.customer.id,
        $scope.filtering.begin_date || '*',
        $scope.filtering.end_date || '*',
        $scope.filtering.reference || '*'
      ])
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'post_date'
    }),
  };

  $scope.getQuotes = ( params ) => {
    return workshopAPI.get('/customers/quote_list_with_find', [
      $scope.customer.id,
      params.offset,
      params.pageSize,
      $scope.filtering.begin_date || '*',
      $scope.filtering.end_date   || '*',
      params.field,
      params.direction,
      $scope.filtering.reference  || '*'
    ]).then(quotes => {
      $scope.quotes = quotes;

      return quotes;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    if ( !$scope.customer.archived ) {
      $scope.viewQuote(event.row);
    }
  };

  $scope.viewQuote = function (quote) {
    $state.go('app.invoice', {
      customer_id: $scope.customer.id,
      id         : quote.id,
      vehicle_id : quote.vehicle_id
    });
  };

  $scope.$watch('[ filtering.begin_date, filtering.end_date, filtering.reference ]', ( newVal, oldVal ) => {
    if (newVal !== oldVal) {
      window['filterQuotes']($scope.filtering);
    }
  }, true);
}
